import React, {Component} from 'react';
import {FormattedMessage, injectIntl} from 'react-intl';
import connect from 'react-redux/es/connect/connect';
import {Card, Radio} from "antd";
import FieldError from "../common/input/FieldError";
import {getSelectedDealerId} from "../../selectors/customerDealer";
import {fetchServiceRepair} from "../../actions/serviceActions";
import {getMobility} from "../../selectors/customerPreJourneyInfo";
import {getMobilityOption} from "../../selectors/createAppointmentRequest";
import Constants from "../../services/Constants";

class MobilityOptions extends Component {

  constructor(props) {
    super(props)
    this.state = {
      extendedOptions: false,
    }
  }

  componentDidMount = () => {
    const {dealerId} = this.props;
    this.props.dispatchFetchServiceRepair({dealerId})
  }

  onChooseSolution = (mobilityOption, mobilityOptionTitle) => {
    this.props.dispatchSaveMobilityOption({
      mobilityOption,
      mobilityOptionTitle,
    });
  };


  renderMobility = () => {
    const {intl: {formatMessage}, mobilityOption} = this.props;

    return Constants.CALL_CENTER_MOBILITIES.map(mobility => {
      return (
        <div className="col-12">
          <Radio
            id={`mobility-${mobility.value}`}
            name='mobility-options'
            checked={mobilityOption === mobility.value}
            onChange={() => this.onChooseSolution(mobility.value, formatMessage({id: mobility.label.id}))}>
            <FormattedMessage id={mobility.label.id}/>
          </Radio>
        </div>
      );
    })
  }

  render = () => {
    const {mobility, mobilityOption} = this.props;

    return (
      <Card title={<h3><FormattedMessage id="section.mobility.title"/></h3>} bordered={false} style={{width: '100%'}}>
        <div className="wrap">
          <div className="content">
            <FormattedMessage id="call.center.journey.step.serviceMobility.mobilityAdvise"/>
            {!mobilityOption && (<FieldError error={{message: 'customer.journey.pleaseChoose'}}/>)}
            <div className="row" style={{marginTop: '25px'}}>
              {this.renderMobility(mobility)}
            </div>
          </div>
        </div>
      </Card>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  dispatchFetchServiceRepair: payload => dispatch(fetchServiceRepair(payload)),
  dispatchSaveMobilityOption: (params) => dispatch({type: 'SAVE.MOBILITY_OPTION', params})
});

const mapStateToProps = state => ({
  dealerId: getSelectedDealerId(state),
  mobility: getMobility(state),
  mobilityOption: getMobilityOption(state),
});

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(MobilityOptions));



// WEBPACK FOOTER //
// ./src/components/call-center/Mobility.js